import { DEFAULT_CANVAS_IMAGE_WIDTH, useEditCanvasStore } from '@air/feature-edit-canvas';

/** Horizontal gap between the last existing node and the first newly-added one. */
const CANVAS_ROW_GAP = 40;

export type CanvasRowItem = { width: number; x: number; y: number };

/**
 * Computes where a new row of nodes should start so it sits to the right of the
 * existing content (at the first node's y) — matching how the selection bar and
 * asset drag-drop place new canvas nodes. Returns the origin for an empty canvas.
 */
export const computeRowStart = (nodes: CanvasRowItem[]): { startX: number; startY: number } => {
  if (nodes.length === 0) {
    return { startX: 0, startY: 0 };
  }

  const startX = nodes.reduce((max, node) => Math.max(max, node.x + node.width), 0) + CANVAS_ROW_GAP;

  return { startX, startY: nodes[0].y };
};

/** Reads the currently-open canvas's nodes from the live editor store. */
export const getOpenCanvasRowItems = (): CanvasRowItem[] => {
  return useEditCanvasStore.getState().nodes.map((node) => ({
    width: typeof node.style?.width === 'number' ? node.style.width : DEFAULT_CANVAS_IMAGE_WIDTH,
    x: node.position.x,
    y: node.position.y,
  }));
};
